/**
 * The Shoorah Videos section's own vocabulary, mapped onto the panel-wide
 * design tokens in component/common/designSystem/theme.js — the same split
 * podsTheme.js uses: only domain meaning lives here, palettes belong to the
 * design system.
 */
import { CHART_COLORS, toneChip, toneLookup } from '../../../../component/common/designSystem';

/**
 * Ordered ramps for the distribution charts. Each is a sequence rather than a
 * set of categories, and each has exactly as many colours as its band list has
 * bands, so a slice never borrows its neighbour's meaning.
 */

// Minutes watched of one video, Under 2 min → Over 20 min. Longer is deeper,
// so this is a plain shallow → deep ramp.
export const WATCH_LENGTH_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.greenDeep,
  CHART_COLORS.green
];

// Distinct videos per viewer, 1 → 8+. Four bands, same direction.
export const VIEWER_DEPTH_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.green
];

// How far people got. Not started → Completed is a journey, so amber sits in
// the middle and completion is the only green.
export const PROGRESS_RAMP = [CHART_COLORS.gray, CHART_COLORS.amber, CHART_COLORS.green];

/**
 * The two video kinds are sources, not a sequence, so they take two distinct
 * hues rather than a ramp. "Unknown" only appears when a watched video has
 * since left the catalogue.
 */
export const KIND_RAMP = [CHART_COLORS.teal, CHART_COLORS.brand, CHART_COLORS.gray];

// Keys match the `kind` strings the backend emits (VIDEO_KIND in
// services/vidsHubService.js), so a chip never has to re-derive the label.
const kindTone = toneLookup({ 'health video': 'teal', 'shoorah vid': 'brand' });

export const kindChipClass = (label) => toneChip(kindTone(label));

const statusTone = toneLookup({
  'not started': 'neutral',
  'in progress': 'warning',
  completed: 'success'
});

export const statusChipClass = (label) => toneChip(statusTone(label));
